export function getTooltipText(hasNote) {
	return hasNote ? $.__('Update Project or Note') : $.__('Add Project or Note');
}

// @startCleanup encore
export function getNoteIcon(hasNote) {
	return hasNote ? 'fab-page-13x16' : 'fab-page-plus-13x16';
}
// @endCleanup encore
